import { Box, Skeleton } from '@mui/material';
import { ReactNode } from 'react';
import { useDashboardChartLayout } from './useDashboardChartLayout';

type ChartSize = 'sm' | 'md' | 'lg';

interface Props {
  children: ReactNode;
  loading?: boolean;
  size?: ChartSize;
}

export default function DashboardChartFrame({ children, loading, size = 'md' }: Props) {
  const { heights } = useDashboardChartLayout();
  const height = heights[size];

  return (
    <Box
      sx={{
        width: '100%',
        minWidth: 0,
        height,
        position: 'relative',
        opacity: loading ? 0.5 : 1,
        '& .recharts-responsive-container': { minWidth: 0, width: '100% !important' },
        '& .recharts-wrapper': { minWidth: 0 },
        '& .recharts-legend-wrapper': {
          width: '100% !important',
          left: '0 !important',
          paddingLeft: 0,
          paddingRight: 0,
        },
      }}
    >
      {loading ? (
        <Skeleton variant="rounded" height={height} sx={{ borderRadius: 2 }} />
      ) : (
        children
      )}
    </Box>
  );
}
